import React, {useCallback} from 'react';
import {MIDI_FX} from 'constants/effect-types.js';
import EffectDropdown from '../EffectDropdown.js';
import RoutingDropdown from './RoutingDropdown.js';
import {
    midiConditionalOptions,
} from '../constants.js';


export default ({
    rack,
    macrosDisabled,
    sequencerEngine,
    handleChooseEffect,
    setEdges,
    setShowMacrosView,
    selectedNodes,
    setMacros}) => {
        const addMacro = useCallback(() => {
            rack.newMacro();
            setMacros([... rack.macros]);
        }, [setMacros]);

        const connectNodes = useCallback(() => {
            rack.connectNodesInSeries(selectedNodes);
            setEdges({... rack.adjacencyLists});
        }, [setEdges, selectedNodes, rack]);
        
        return (
            <div className="rack-toolbar">
             <EffectDropdown
                track={rack.track}
                isMidiEffect={rack.getEffectType() === MIDI_FX}
                sequencerEngine={sequencerEngine}
                handleChooseEffect={handleChooseEffect}/>
              {rack.getEffectType() === MIDI_FX ? 
               <EffectDropdown
                 track={rack.track}
                 isMidiEffect={rack.getEffectType() === MIDI_FX}
                 placeholder={"Flow"}
                 options={midiConditionalOptions}
                 sequencerEngine={sequencerEngine}
                 handleChooseEffect={handleChooseEffect}/>
               : ''}
             
              {macrosDisabled ? '' :
               [(
                   <div
                     key={1}
                     onClick={addMacro}
                     className="add-macro-button">
                     Add Macro
                   </div>),
                (<div
                     key={2}
                   onClick={() => setShowMacrosView(true)}
                   className="show-macros-button">
                   Macros
                 </div>)]
              }

              {selectedNodes.length > 1 ?
               <div
                 onClick={connectNodes}
                 className="add-macro-button">Connect Nodes</div> :
               ''}
            </div>
        );
};
